import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const coworkingMinPriceSelector = createSelector(
  coworkingSelector,
  coworking => coworking?.minPriceForWorkplace ?? null,
);
